import React, { PureComponent } from 'react'

const PureItemHOC = (ComponentParentProps, ComponentParent, ComponentToRender) => {
  return class PureItem extends PureComponent {
    render() {
      return (
        <ComponentParent {...ComponentParentProps}>
          <ComponentToRender {...this.props} />
        </ComponentParent>
      )
    }
  }
}

export default PureItemHOC



// WEBPACK FOOTER //
// ./src/containers/HOC/PureItemHOC.js